import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=94806fd2&scoped=true&"
import script from "./promotion.vue?vue&type=script&lang=js&"
export * from "./promotion.vue?vue&type=script&lang=js&"
import style0 from "./promotion.vue?vue&type=style&index=0&id=94806fd2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94806fd2",
  null
  
)

export default component.exports